import '../modals.css';

import { useRecoilValue } from 'recoil';
import { userConfigState } from '../../../recoil/atoms/userConfigState';
import { useOpenGlobalModal } from '../../../recoil/hooks/useOpenGlobalModal';

import CloseIcon from '@mui/icons-material/Close';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

import { translate } from '../../../../common/language/translations';
import { IconButton } from '../../controls/buttons/IconButton';
import { getAccessTableOptionIcon } from '../../../utils/iconUtils';
import { LogisticTeamAccess, ReportAccess } from '../../../types/user';
import { OptionButton } from '../../controls/buttons/OptionButton';


interface AccessTableOptionModalProps {
  accountTableOptionModalType: string | undefined;
  closeModal: (event?: React.MouseEvent) => void;
  selectedOption: LogisticTeamAccess | ReportAccess;
  handleOptionClick?: (option: string) => void;
}


export const AccessTableOptionModal: React.FC<AccessTableOptionModalProps> = ({
  accountTableOptionModalType,
  closeModal,
  selectedOption,
  handleOptionClick,
}) => {

  const userConfig = useRecoilValue(userConfigState);

  const { openTextModal } = useOpenGlobalModal();

  const options: LogisticTeamAccess[] | ReportAccess[] = accountTableOptionModalType === 'logisticTeamAccess'
    ? ['full', 'personal', 'none']
    : accountTableOptionModalType === 'reportAccess'
      ? ['full', 'academy', 'personal', 'none']
      : [];


  const onOptionClick = (option: string, isSelected: boolean) => {
    if (handleOptionClick && !isSelected) {
      handleOptionClick(option);
      closeModal();
    }
  };

  return (
    <div className='modal-root-container' style={{ width: 400, height: 100 + (options.length * 50) }}>
      <IconButton
        icon={<CloseIcon style={{ fontSize: 24 }} />}
        onClick={closeModal}
        size={30}
        style={{ position: 'absolute', top: 12, right: 12 }}
        startWhite={true}
      />

      <div className='modal-root-title'>
        {translate(accountTableOptionModalType ?? '', userConfig?.language)}
      </div>

      <div className='modal-divider modal-root-title-divider' />

      <div className='modal-content-container'>
        <div className='modal-option-column' style={{ marginTop: 30 }}>
          {options.map(option => {

            const icon = getAccessTableOptionIcon(option, 22, 'colored');
            const isSelected = option === selectedOption;

            return (
              <div
                key={option}
                style={{ position: 'relative' }}
              >
                <IconButton
                  icon={<InfoOutlinedIcon style={{ fontSize: 16 }} />}
                  onClick={(event) => {
                    event?.stopPropagation();
                    openTextModal(
                      translate(option + '_' + accountTableOptionModalType, userConfig?.language),
                      translate(option + '_' + accountTableOptionModalType + 'Info', userConfig?.language),
                    );
                  }}
                  size={24}
                  style={{ position: 'absolute', left: -40, marginTop: 3 }}
                />

                <OptionButton
                  onClick={() => onOptionClick(option, isSelected)}
                  option={option + '_' + accountTableOptionModalType}
                  language={userConfig?.language}
                  optionIsSelected={isSelected}
                  icons={{ leftIcon: icon }}
                  style={{ width: 250, gap: 1, fontSize: 13 }}
                />
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};
